import React from 'react';
import { Navbar } from '../components/Navbar';
import { CertificationPage } from '../components/CertificationPage';
import { Footer } from '../components/Footer';
export const Certification = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2337" data-mp="fhlelq0oir3g">
      <Navbar data-id="element-2338" data-mp="fk7qg1ulrsrh" />
      <CertificationPage data-id="element-2339" data-mp="ajjyndyjv7w7" />
      <Footer data-id="element-2340" data-mp="ai8jkhznmdps" />
    </div>;
};